module.exports = __webpack_public_path__ + "img/T2A_xs_00.eeb8d1cf.png";